import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import SourcingCapabilities from './pages/SourcingCapabilities'
import WorkWithGrace from './pages/WorkWithGrace'
import Projects from './pages/Projects'
import About from './pages/About'
import Insights from './pages/Insights'
import SludgeDewatering from './pages/SludgeDewatering'
import WastewaterTreatment from './pages/WastewaterTreatment'
import OdorControl from './pages/OdorControl'
import Contact from './pages/Contact'

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/sourcing-capabilities" element={<SourcingCapabilities />} />
        <Route path="/work-with-grace" element={<WorkWithGrace />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<About />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/sludge-dewatering-equipment" element={<SludgeDewatering />} />
        <Route path="/wastewater-treatment-equipment" element={<WastewaterTreatment />} />
        <Route path="/odor-control-equipment" element={<OdorControl />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
    </Routes>
  )
}

export default App
